module.exports = __webpack_public_path__ + "static/media/29ADMSPC27.92ee389a.jpg";